<template>
	<div class="yingen-contact-wrap">
		<div class="info-item-wrap">
			<div v-for="item in infoItemList" :key="item.value" class="info-item">
				<div>
					<p class="item-label">{{ item.label }}</p>
					<p class="item-value">{{ item.value }}</p>
				</div>
				<SvgIcons :name="item.icon" class="item-icon" />
			</div>
		</div>
	</div>
</template>

<script setup>
import { useCurrentReactive } from './context';

const { infoItemList } = useCurrentReactive();
</script>

<style lang="less" scoped>
.yingen-contact-wrap {
    padding: 17px 14px;
	.info-item-wrap {
		display: flex;
		flex-direction: column;
		gap: 20px;
	}
	.info-item {
		display: flex;
		align-items: center;
		justify-content: space-between;
		padding: 16px;
		border-radius: 16px;
		background: #f2f2f2;
		backdrop-filter: blur(40px);
		.item-icon {
			width: 56px;
			height: 56px;
		}
		.item-label {
			padding-bottom: 12px;
			color: var(--t-emphasis-color, #1d2129);
			font-size: 16px;
			font-weight: 500;
			line-height: 24px; /* 150% */
		}
		.item-value {
			color: var(--t-secondary-color, #4e5969);
			font-size: 14px;
			font-weight: 400;
			line-height: 18px; /* 128.571% */
		}
	}
}
</style>

<style lang="less"></style>
